<template>
  <div class="im-nav" ref="nav">
    <div v-if="items" class="im-nav__items" ref="items">
      <div class="im-nav__item"
           v-for="(item, index) in items"
           :key="index"
           :class="[{open: item.key === activeItem, highlight: item.newMessageCount}]"
           @click="open(item)"
      >
        <div class="im-nav__item-title">{{ item.title }}</div>
        <div class="im-nav__item-close" @click.stop="close(item)">
          <svg>
            <use xlink:href="#icon-close"></use>
          </svg>
        </div>
      </div>
    </div>
    <div class="im-nav__arrows" v-if="isScroll">
      <div class="im-nav__arrow im-nav__arrow-left"
           @click="scrollItems(-1)"></div>
      <div class="im-nav__arrow im-nav__arrow-right"
           @click="scrollItems(1)"></div>
    </div>
  </div>
</template>

<script>
  import { dialog } from '../../mixins/dialog';

  export default {
    name: 'Nav',
    mixins: [dialog],
    data() {
      return {
        widthItems: 0,
        widthItem: 0,
        isScroll: false,
        scrollValue: 0
      };
    },
    computed: {
      items() {
        return this.$store.state.dialogs;
      },
      activeItem() {
        const dialog = this.$store.state.dialog;
        if (dialog && dialog.key) {
          return dialog.key;
        }
      }
    },
    watch: {
      items() {
        this.checkCapacity();
      }
    },
    mounted() {
      this.checkCapacity();
    },
    methods: {
      init() {

      },
      open(data) {
        this.openDialog(data);
      },
      close(data) {
        this.closeDialog(data);
      },
      checkCapacity() {
        this.$nextTick().then(() => {
          const items = this.$refs.items.querySelectorAll('.im-nav__item');
          this.widthItems = 0;
          items.forEach(item => {
            this.widthItems += item.clientWidth;
          });
          this.widthItems > this.$refs.nav.clientWidth
            ? this.isScroll = true
            : this.isScroll = false;
        });
      },
      scrollItems(dir) {
        if (dir < 0) {
          this.scrollValue -= 143;
          const delta = this.widthItems + this.scrollValue + 143;
          this.scrollValue = delta < this.$refs.nav.clientWidth ? this.scrollValue += 143 : this.scrollValue;
        }
        if (dir > 0) {
          this.scrollValue += 143;
          this.scrollValue = this.scrollValue > 0 ? 0 : this.scrollValue;
        }
        this.$refs.items.style.left = this.scrollValue + 'px';
      }
    }
  };
</script>

<style lang="scss">
  .im-nav {
    $root: &;
    flex-shrink: 0;
    overflow: hidden;
    position: relative;

    &__items {
      display: flex;
      align-items: center;
      box-sizing: border-box;
      border-bottom: 1px solid #D6D6D6;
      width: 10000px;
      position: relative;
    }

    &__item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      box-sizing: border-box;
      border-right: 1px solid #D6D6D6;
      padding: 10px;
      position: relative;
      font-size: 12px;

      &:hover {
        cursor: pointer;
      }
      &.highlight {
        #{$root}__item-title {
          color: #E54545;
        }
      }

      &.open {
        #{$root}__item-title {
          font-weight: bold;
          color: #1588E2;
        }

        #{$root}__item-close {
          svg {
            fill: #E54545;
          }
        }
      }

      &.open {
        &::after {
          display: block;
          content: "";
          background: #FFF;
          width: 100%;
          height: 1px;
          position: absolute;
          left: 0;
          bottom: -1px;
        }
      }
    }

    &__item-title {
      flex-shrink: 0;
      overflow: hidden;
      box-sizing: border-box;
      margin: 0 10px 0 0;
      /*width: 100px;*/
      white-space: nowrap;
      text-overflow: ellipsis;
      color: #77808C;
    }

    &__item-close {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
      /*background: #E54545;*/
      border-radius: 50%;
      width: 12px;
      height: 12px;

      svg {
        fill: #77808C;
        width: 10px;
        height: 10px;
      }
    }

    &__arrows {
      background: #FFF;
      border-bottom: 1px solid #D6D6D6;
      border-left: 1px solid #D6D6D6;
      width: 20px;
      height: 40px;
      position: absolute;
      top: 0;
      right: 0;
    }

    &__arrow {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 17px;
      height: 17px;
      position: absolute;
      top: 0;
      left: 0;

      &::after {
        display: block;
        content: "";
        margin: 0 -4px 0 0;
        width: 0;
        height: 0;
      }
    }

    &__arrow-left {
      &::after {
        border-top: 4px solid transparent;
        border-right: 4px solid transparent;
        border-bottom: 4px solid transparent;
        border-left: 4px solid #8d96a1;
        margin: 0 -4px 0 0;
      }
    }

    &__arrow-right {
      top: 20px;

      &::after {
        border-top: 4px solid transparent;
        border-right: 4px solid #8d96a1;
        border-bottom: 4px solid transparent;
        border-left: 4px solid transparent;
        margin: 0 0 0 -4px;
      }
    }
  }
</style>